import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';
import { Meta, Notice, LinkRow } from './css';
import { downloadReport, errorMessageFrom } from './api';

const formatWhen = (value) => {
  if (!value) return null;
  const when = new Date(value);
  return Number.isNaN(when.getTime()) ? null : when.toLocaleString();
};

const RunResults = ({ run }) => {
  const [reportError, setReportError] = useState(null);
  const [downloading, setDownloading] = useState(false);

  const ranAt = formatWhen(run.finishedAt || run.dispatchedAt);

  const download = async () => {
    setReportError(null);
    setDownloading(true);
    try {
      const stamp = (run.finishedAt || run.dispatchedAt || '').slice(0, 10);
      const suffix = stamp ? `-${stamp}` : '';
      await downloadReport(run.runId, `${run.sectionId}${suffix}.pdf`);
    } catch (err) {
      setReportError(errorMessageFrom(err, 'The report could not be downloaded.'));
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <Meta style={{ margin: 0 }}>
        {ranAt || 'Run time unavailable'}
        {run.triggeredByName ? ` · Started by ${run.triggeredByName}` : ''}
      </Meta>

      {run.errorMessage && <Notice tone="error">{run.errorMessage}</Notice>}

      <LinkRow>
        {run.reportUrl ? (
          <Button
            variant={{ priority: 'low' }}
            type="button"
            onClick={download}
            inactive={downloading}
          >
            {downloading ? 'Downloading…' : 'Download report (PDF)'}
          </Button>
        ) : (
          <Notice>No report stored for this run.</Notice>
        )}
      </LinkRow>

      {reportError && <Notice tone="error">{reportError}</Notice>}
    </>
  );
};

RunResults.propTypes = {
  run: PropTypes.shape({
    runId: PropTypes.string.isRequired,
    sectionId: PropTypes.string,
    dispatchedAt: PropTypes.string,
    finishedAt: PropTypes.string,
    triggeredByName: PropTypes.string,
    errorMessage: PropTypes.string,
    reportUrl: PropTypes.string
  }).isRequired
};

export default RunResults;
